import ButtonGroup from "@mui/material/ButtonGroup";
import Chip from "@mui/material/Chip";
import { memo } from "react";
import * as advancedExchange from "./advanced-exchange.module.css";

export const Selector = memo(function Selector({
  showingSimilarItems,
  setShowingSimilarItems,
  clearSearchResults,
}: {
  showingSimilarItems: boolean;
  setShowingSimilarItems: (showingSimilarItems: boolean) => void;
  clearSearchResults: () => void;
}) {
  const getChipStyles = (isLeft: boolean, isSelected: boolean) => {
    let styles = {
      width: "190px",
      "& .MuiChip-label": { lineHeight: "normal" },
    };
    styles = isLeft
      ? { ...styles, ...{ marginRight: "-18px" } }
      : (styles = { ...styles, ...{ marginLeft: "-18px" } });
    if (isSelected) {
      styles = { ...styles, ...{ backgroundColor: "black", color: "white" } };
    } else {
      styles = { ...styles, ...{ color: "gray" } };
      styles = isLeft
        ? { ...styles, ...{ paddingRight: "30px" } }
        : (styles = { ...styles, ...{ paddingLeft: "20px" } });
    }

    return styles;
  };

  return (
    <ButtonGroup
      aria-label="outlined primary button group"
      className={advancedExchange.selector}
      // sx={{ boxShadow: "none" }}
      variant="contained"
    >
      <Chip
        label="Similar to My Order"
        onClick={
          !showingSimilarItems
            ? () => {
                clearSearchResults();
                setShowingSimilarItems(true);
              }
            : undefined
        }
        sx={getChipStyles(true, showingSimilarItems)}
      />
      <Chip
        label="Full Catalog"
        onClick={
          showingSimilarItems
            ? () => {
                setShowingSimilarItems(false);
              }
            : undefined
        }
        sx={getChipStyles(false, !showingSimilarItems)}
      />
    </ButtonGroup>
  );
});
